import React from 'react'

const Info = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M13.9304 0.893125L18.7476 20.1629L26.5681 22.7279C26.8058 22.8059 26.9353 23.0619 26.8574 23.2995C26.7794 23.5371 26.5236 23.6665 26.286 23.5885L18.2967 20.9682H8.47896L1.16082 23.5848C0.925367 23.6689 0.666354 23.5462 0.582135 23.3108C0.497933 23.0753 0.620599 22.8161 0.85611 22.7319L8.023 20.1693L13.0527 0.888703L13.9304 0.893125ZM8.98689 20.0625H17.789L13.4815 2.83306L8.98689 20.0625Z" fill="#494949"/>
      <path d="M27.4198 23.629L13.4228 28L0 23.6261L13.4174 0L27.4198 23.629ZM13.8787 26.9087L26.057 23.1056L13.8787 2.55488V26.9087ZM1.33538 23.1087L12.973 26.9008V2.61636L1.33538 23.1087Z" fill="#494949"/>
    </svg>
  )
}

export default Info
